// extracted by mini-css-extract-plugin
export var abbr = "Markdown-module--abbr--81489";
export var blockquote = "Markdown-module--blockquote--7244d";
export var cdsAssistiveText = "Markdown-module--cds--assistive-text--e29b9";
export var cdsVisuallyHidden = "Markdown-module--cds--visually-hidden--f7d3f";
export var h1 = "Markdown-module--h1--b5ebf";
export var h2 = "Markdown-module--h2--e4857";
export var h3 = "Markdown-module--h3--923f9";
export var h4 = "Markdown-module--h4--4fd57";
export var h5 = "Markdown-module--h5--8824c";
export var h6 = "Markdown-module--h6--57454";
export var hideFeedback = "Markdown-module--hide-feedback--aa1e4";
export var list = "Markdown-module--list--7da99";
export var listItem = "Markdown-module--list-item--171ee";
export var paragraph = "Markdown-module--paragraph--29381";
export var paragraphResponsive = "Markdown-module--paragraph--responsive--7fcac";
export var showFeedback = "Markdown-module--show-feedback--ca2a4";
export var skeleton = "Markdown-module--skeleton--9196a";
export var sup = "Markdown-module--sup--33226";